<template>
  
  <v-navigation-drawer :width="275" class="text-left" expand-on-hover rail>

    <v-list>
      <v-list-item prepend-icon="mdi-view-dashboard-outline" link title="dashboard" to="/dashboard"></v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list>
      <v-list-item prepend-icon="mdi-home-city-outline" link title="properties" to="/properties"></v-list-item>
      <v-list-item prepend-icon="mdi-car-outline" link title="vehicles" to="/vehicles"></v-list-item>
      <v-list-item prepend-icon="mdi-diamond-stone" link title="collectibles" to="/collectibles"></v-list-item>
      <v-list-item prepend-icon="mdi-cash-multiple" link title="cash" to="/cash"></v-list-item>
      <v-list-item prepend-icon="mdi-bank" link title="loans" to="/loans"></v-list-item>
      <v-list-item prepend-icon="mdi-apps" link title="securities" to="/securitiessummary"></v-list-item>
      <v-list-item prepend-icon="mdi-book-settings-outline" link title="super funds" to="/superfunds"></v-list-item>
      <v-list-item prepend-icon="mdi-package-variant-closed" link title="other" to="/otherassets"></v-list-item>   
    </v-list>

    <v-divider></v-divider>

    <v-list>
      <v-list-item prepend-icon="mdi-account-cash-outline" link title="salaries" to="/salaries"></v-list-item>
    </v-list>

    <v-divider></v-divider>
    
    <v-list>
      <v-list-item prepend-icon="mdi-credit-card-fast-outline" link title="expenses" to="/expenses"></v-list-item>
      <v-list-item prepend-icon="mdi-invoice-text-check-outline" link title="banking" to="/bankaccountsummary"></v-list-item>
    </v-list>
    
    <v-divider></v-divider>
    
    <v-list>
      <v-list-item prepend-icon="mdi-code-block-brackets" link title="security categories" to="/securitycategories"></v-list-item>
      <v-list-item prepend-icon="mdi-chart-donut" link title="portfolio allocation" to="/portfolioallocation"></v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list>
      <v-list-item prepend-icon="mdi-eye-outline" link title="watchlist" to="/watchlist"></v-list-item>
      <v-list-item prepend-icon="mdi-bell-outline" link title="notifications" to="/notifications"></v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list>
      <v-list-item prepend-icon="mdi-chart-timeline-variant" link title="modelling" to="/modelling"></v-list-item>
      <v-list-item prepend-icon="mdi-camera-outline" link title="portfolio snapshot" to="/reports"></v-list-item>
      <v-list-item prepend-icon="mdi-scale-balance" link title="cgt disposals" to="/reports/cgt-disposals"></v-list-item>
      <v-list-item prepend-icon="mdi-cart-outline" link title="acquisitions" to="/reports/acquisitions"></v-list-item>
      <v-list-item prepend-icon="mdi-trending-up" link title="performance" to="/reports/investment-performance"></v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list>
      <v-list-item prepend-icon="mdi-cog-outline" link title="admin" to="/admin"></v-list-item>
    </v-list>

  </v-navigation-drawer>

</template>

<script>


</script>


<style>
.v-navigation-drawer__content {
  overflow-y: auto !important;
}

.v-navigation-drawer--rail .v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}

.v-navigation-drawer--rail .v-navigation-drawer__content {
  scrollbar-width: none;
}
</style>